import React from 'react';
import {withStyles} from "@material-ui/core/styles";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Background from "../assets/community/trees.png";

const muiTheme = createTheme({
    palette: {
        custom: {
            main: '#FFF'
        },
    },
    components: {
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: "#000",
                }
            }
        }
    }
});

const useStyles = theme => ({
    sticker: {
        display: 'flex',
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        background: 'linear-gradient(180deg, #0E8064 0%, #01C595 100%)',
        borderRadius: '50%',
        border: '4px solid #fff',
        width: '152px',
        height: '152px',
        overflow: 'hidden',
    },
    background: {
        zIndex: '1',
        position: 'absolute',
        width: '100%',
        height: '110px',
        bottom: '0px',
        backgroundImage: 'url(' + Background + ')',
    },
    data: {
        zIndex: '2',
        color: '#fff',
        textTransform: 'uppercase'
    },
    total: {
        padding: '16px 0 0 0',
        fontFamily: 'Montserrat',
        fontSize: '2.6em',
        fontWeight: 'bold',
        lineHeight: '1em'
    },
    trees: {
        fontFamily: 'Montserrat',
        fontSize: '1.1em',
        fontWeight: 'bold',
        lineHeight: '1.4em',
        letterSpacing: '0.1em',
        padding: '8px 18px'
    },
});

class CommunityStickerPanel extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            totalTrees: 0
        };
    }

    componentDidMount() {
        let self = this;

        // get donations
        fetch('https://www.projectalprun.com/api/getalldonations')
            .then(response => response.json())
            .then(data => {
                self.setState({ totalTrees: data.amount });
            })
    }

    render() {
        const { classes } = this.props;
        let self = this;

        let formattedTotalTrees = new Intl.NumberFormat().format(self.state.totalTrees);

        return (
            <ThemeProvider theme={muiTheme}>

            <div className={classes.sticker}>
                <div className={classes.background}></div>

                <div className={classes.data}>
                    <div className={classes.total}>{formattedTotalTrees}</div>
                    <div className={classes.trees}>trees planted</div>
                </div>


            </div>

            </ThemeProvider>
        )
    }
}

export default withStyles(useStyles)(CommunityStickerPanel)